import { memo, ReactNode, useCallback } from "react";

import { ListItem, ListItemProps } from "./list-item";
import { Icon, Row, TextBody } from "../lib";
import { colors, createStyles, sizes } from "../theme";
import { openUrl } from "../services";

type Props = ListItemProps<string> & {
  addon?: ReactNode;
  invalid?: boolean;
  label: string;
  last?: boolean;
  url?: string;
};

export const MenuListItem = memo(function PlaceListItem({
  addon,
  invalid = false,
  label,
  last = false,
  url,
  ...rest
}: Props) {
  const handlePress = useCallback(() => {
    if (url) {
      openUrl(url);
    }

    rest.onPress?.(rest.id);
  }, [rest, url]);

  return (
    <ListItem {...rest} onPress={handlePress} style={$.container}>
      <Row.LR style={[$.inner, last && $.last]}>
        <TextBody ml="4">{label}</TextBody>

        <Row.R style={$.icons}>
          {addon}
          {invalid && <Icon name="alert-circle" color="onError" />}
          <Icon name={url ? "open-in-new" : "chevron-right"} />
        </Row.R>
      </Row.LR>
    </ListItem>
  );
});

const $ = createStyles({
  container: {
    // TODO: Fix theme sheet "0"spacing value is not found
    p: "0",
    pl: "4",
  },
  inner: {
    borderBottomColor: colors.outline,
    borderBottomWidth: 1,
    py: "4",
    pr: "4",
  },
  last: {
    borderBottomWidth: 0,
  },
  icons: {
    gap: sizes["2"],
  },
});
